// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"72":"b35d1760","111":"b85c30e5","359":"b85c30e5","448":"7e499db3","936":"bb177654"}[chunkId] + ".css";
};